import { useParams, useNavigate } from 'react-router-dom'
import { useMyOfferings, useUpdateOffering, useDeleteOffering } from '@/hooks/useOfferings'
import { useEffect, useMemo, useState } from 'react'
import Button from '@/components/common/Button/Button'
import Input from '@/components/forms/Input/Input'
import routes from '@/routes/routes'
import './ProviderOfferingDetail.css'

const ProviderOfferingDetail = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const offeringId = Number(id)
    const { data, isLoading, isError } = useMyOfferings()
    const update = useUpdateOffering()
    const del = useDeleteOffering()
    const offering = useMemo(() => (data || []).find((o: any) => o.id === offeringId), [data, offeringId])

    const [description, setDescription] = useState('')
    const [price, setPrice] = useState('')

    useEffect(() => {
        if (offering) {
            setDescription(offering.description || '')
            setPrice(String(offering.price_per_hour || ''))
        }
    }, [offering])

    const handleSave = async () => {
        await update.mutateAsync({ id: offeringId, data: { description, price_per_hour: Number(price) } })
    }
    const handleDelete = async () => {
        await del.mutateAsync(offeringId)
        navigate(routes.providerServices)
    }

    return (
        <div className="provider-offering-detail-page">
            <div className="provider-offering-detail-container">
                <h1 className="provider-offering-detail-title">Detalle del Servicio #{id}</h1>
                {isLoading ? (
                    <div className="provider-offering-detail-message">Cargando...</div>
                ) : isError ? (
                    <div className="provider-offering-detail-message">Error al cargar</div>
                ) : offering ? (
                    <div className="provider-offering-detail-content">
                        <div><strong>Servicio:</strong> {offering.service_name}</div>
                        <Input name="price" label="Precio por hora" placeholder="Precio" value={price} setValue={setPrice} effect3d={false} />
                        <Input name="description" label="Descripción" placeholder="Descripción" value={description} setValue={setDescription} multiline rows={4} effect3d={false} />
                        <div className="provider-offering-detail-actions">
                            <Button variant="primary" onClick={handleSave} disabled={update.isPending || !price} effect3d={false}>Guardar</Button>
                            <Button variant="danger" onClick={handleDelete} disabled={del.isPending} effect3d={false}>Eliminar</Button>
                        </div>
                    </div>
                ) : (
                    <div className="provider-offering-detail-message">Servicio no encontrado</div>
                )}
            </div>
        </div>
    )
}

export default ProviderOfferingDetail


